export default __webpack_public_path__ + "static/media/Shalimar-Regular.1b20948a.woff2";